angular.module('v3sWbtPlayerApp').provider('v3sLoaderService', function () {

    var ressource = [];

    function loadPath(fileName, deferred) {
        if (typeof !!v3sWbtPlayer && !!v3sWbtPlayer[fileName]) {
            ressource[fileName] = v3sWbtPlayer[fileName];
            deferred.resolve(ressource[fileName]);
        } else if (!!ressource[fileName]) {
            deferred.resolve(ressource[fileName]);
        } else {
            deferred.reject("Content cannot be loaded: " + fileName);
        }
    }

    this.$get = ["$document", "$q", "$timeout", function ($document, $q, $timeout) {
        return function (fileName, folder) {
            var deferred = $q.defer();

            if (!!ressource[fileName]) {
                deferred.resolve(ressource[fileName]);               
            } else {
                var path = folder + fileName;
                var script = $document[0].createElement('script');

                var done = false;
                script.onload = script.onreadystatechange = function () {
                    if (!done && (!this.readyState || this.readyState === "loaded" || this.readyState === "complete")) { //ie9 bug: 2x ready
                        done = true;
                        $timeout(function () {
                            loadPath(fileName, deferred);
                            $document[0].body.removeChild(script);
                            delete v3sWbtPlayer[fileName];
                        }, 5);

                    }
                };

                script.onerror = function () {
                    $timeout(function () {
                        deferred.reject("File not found: " + path);
                        $document[0].body.removeChild(script);
                        delete v3sWbtPlayer[fileName];
                    });
                };

                script.src = path;
                $document[0].body.appendChild(script);
            }

            return deferred.promise;
        };
    }];
});
